import client from "../client";
import { DepartmentInterface } from "../../models/TicketModule/Department";

class DepartmentService {
  async GetAll(page: number, pageSize: number) {
    try {
      let url = `/api/Departments`;

      if (page > 0 && pageSize > 0) {
        url += `?page=${page}&pageSize=${pageSize}`;
      }
      const { data } = await client.get<DepartmentInterface[]>(url);
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GetById(id: string) {
    try {
      let url = `/api/Departments/getbyid/${id}`;

      const { data } = await client.get<DepartmentInterface>(url);

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Save(priority: DepartmentInterface) {
    try {
      let url = `/api/Departments`;

      const { data } = await client.post<DepartmentInterface>(url, priority);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async Update(id: string, priority: DepartmentInterface) {
    try {
      let url = `/api/Departments/update/${id}`;

      const { data } = await client.post<DepartmentInterface>(url, priority);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async Remove(id: string) {
    try {
      let url = `api/Departments/remove/${id}`;
      await client.post<DepartmentInterface>(url, { url: "" });
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}

export default new DepartmentService();
